// plugins/paywall-directive.ts
import type { Directive } from 'vue'
import { createApp } from 'vue'
import PaywallGate from '@/components/am3/paywall/AM3Paywall.vue'

export const vPaywall: Directive = {
  mounted(el, binding) {
    const props = binding.value
    const mountPoint = document.createElement('div')
    el.appendChild(mountPoint)
    const gateApp = createApp(PaywallGate, props)
    gateApp.mount(mountPoint)
    ;(el)._gateApp = gateApp
  },
  unmounted(el) {
    const gateApp = (el)._gateApp
    if (gateApp) gateApp.unmount()
  },
}
